import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { TextField, Grid, Button } from "@mui/material";
import { addDoc, collection } from "firebase/firestore";
import { dbFirebase } from "../../Conections/Firebase";
import Swal from "sweetalert2";
import bcrypt from "bcryptjs";
import { getCurrentDateTime } from "../../Utils/dateUtils";

// Validación del formulario
const validationSchema = yup.object({
  nombre: yup.string().required("Nombre requerido"),
  user: yup.string().required("Usuario requerido"),
  email: yup.string().email("Correo inválido").required("Correo requerido"),
  rol: yup.string().required("Rol requerido"),
  totalDeuda: yup
    .number()
    .min(0, "Debe ser mayor o igual a 0")
    .when("rol", {
      is: "Deudor",
      then: (schema) => schema.required("Total de deuda requerido"),
      otherwise: (schema) => schema.transform(() => 0),
    }),
});

const DeudorFormDialog = ({ onSuccess }) => {
  const formik = useFormik({
    initialValues: {
      nombre: "",
      user: "",
      email: "",
      rol: "Deudor",
      totalDeuda: 0,
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const hashedPassword = await bcrypt.hash("12345678", 10); // Contraseña fija y encriptada

        const newDeudor = {
          ...values,
          password: hashedPassword,
          prestamoActivo: values.rol === "Deudor" && Number(values.totalDeuda) > 0,
          numeroPrestamoActual:
            values.rol === "Deudor" && Number(values.totalDeuda) > 0 ? 1 : 0,
          fechaInicioPrestamoActual:
            values.rol === "Deudor" && Number(values.totalDeuda) > 0
              ? getCurrentDateTime()
              : null,
          prestamoLiquidadoAt: null,
        };

        await addDoc(collection(dbFirebase, "deudores"), newDeudor);

        Swal.fire({
          icon: "success",
          title: "Deudor agregado",
          text: "El deudor fue registrado correctamente",
        });

        resetForm();
        onSuccess();
      } catch (error) {
        console.error("Error agregando deudor:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo registrar el deudor",
        });
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nombre"
            name="nombre"
            value={formik.values.nombre}
            onChange={formik.handleChange}
            error={formik.touched.nombre && Boolean(formik.errors.nombre)}
            helperText={formik.touched.nombre && formik.errors.nombre}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Usuario"
            name="user"
            value={formik.values.user}
            onChange={formik.handleChange}
            error={formik.touched.user && Boolean(formik.errors.user)}
            helperText={formik.touched.user && formik.errors.user}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Correo electrónico"
            name="email"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="rol"
            name="rol"
            select
            label="Rol"
            value={formik.values.rol}
            onChange={(e) => {
              const newRol = e.target.value;
              formik.setFieldValue("rol", newRol);
              if (newRol === "Administrador") {
                formik.setFieldValue("totalDeuda", 0);
              }
            }}
            SelectProps={{ native: true }}
          >
            <option value="Deudor">Deudor</option>
            <option value="Administrador">Administrador</option>
          </TextField>
        </Grid>

        {formik.values.rol === "Deudor" && (
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="totalDeuda"
              name="totalDeuda"
              label="Total de deuda"
              type="number"
              value={formik.values.totalDeuda}
              onChange={formik.handleChange}
              error={
                formik.touched.totalDeuda && Boolean(formik.errors.totalDeuda)
              }
              helperText={formik.touched.totalDeuda && formik.errors.totalDeuda}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <Button fullWidth type="submit" variant="contained" color="primary">
            Registrar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default DeudorFormDialog;
